import {
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { Elements } from "@stripe/react-stripe-js";
import { useQuery, useQueryClient } from "react-query";
import { paymentIntent } from "../../../services/userApi";
import { getStripePromise } from "../../../services/stripe";
import PaymentMethodForm from "./PaymentMethodForm";

const PaymentMethodModal = ({ isOpen, onClose }) => {
  const queryClient = useQueryClient();
  const toast = useToast();
  const { data, isSuccess, isLoading } = useQuery("intent", paymentIntent, {
    refetchOnWindowFocus: false,
  });

  const onSuccess = () => {
    // Success toast
    toast({
      title: "Payment method updated",
      description: "Your payment method has been updated.",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
    // Invalidate the query to force a re-fetch
    queryClient.refetchQueries(["billing"]);
    onClose();
  };

  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered>
      <ModalOverlay />
      <ModalContent bg="white">
        <ModalHeader color="gray.900">Update payment method</ModalHeader>
        <ModalCloseButton color="gray.900" />
        <ModalBody>
          {isLoading && (
            <Center p="6">
              <Spinner color="red" />
            </Center>
          )}

          {isSuccess && data && (
            <VStack spacing={4}>
              <Elements
                stripe={getStripePromise()}
                options={{
                  clientSecret: data.intent.clientSecret,
                }}
              >
                <PaymentMethodForm onSuccess={onSuccess} />
              </Elements>
            </VStack>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PaymentMethodModal;
